import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import EditIcon from "@material-ui/icons/Edit";
import { makeStyles } from "@material-ui/core/styles";
import { useParams } from "react-router-dom";
import history from "../../utils/History";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import useAuth from "../../hooks/Auth";
import VisibilityIcon from '@material-ui/icons/Visibility';
import Roles from "../../constants/Roles";
import DnerhsApi from "api/DnerhsApi";

const useStyles = makeStyles((theme) => ({
  main: {
    paddingLeft: theme.spacing(10),
    paddingRight: theme.spacing(10),
  },
  form: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  field: {
    margin: theme.spacing(),
  },
}));

// Definición de un arreglo llamado `secciones` que contiene objetos. 
// Cada objeto representa una sección de un formulario o proceso, con su respectivo ID, descripción, estado y ruta (path) a seguir en la aplicación.
const secciones = [
  {
    id: 1,  // Identificador único de la sección
    descripcion: "Datos generales del campo de práctica",  // Descripción de la sección
    estado: "Datos cargados",  // Estado actual de los datos en esa sección
    path: "/establecimientos/camposPractica/crear",  // Ruta a la cual se redirige al hacer clic en la sección
  },
  {
    id: 2,
    descripcion: "Datos del encargado del campo de práctica",
    estado: "3 Carreras/Programas cargadas",
    path: "/establecimientos/encargadoCamposPractica/crear",
  },
  {
    id: 3,
    descripcion: "Infraestructura",
    estado: "Sin carga",
    path: "/establecimientos/capacidadCamposPractica/crear",
  },
  {
    id: 4,
    descripcion: "Profesional de salud",
    estado: "Sin carga",
    path: "/establecimientos/profesionalCamposPractica/crear",
  },
  {
    id: 5,
    descripcion: "Cartera de Servicios",
    estado: "Datos cargados",
    path: "/establecimientos/servicioCamposPractica/crear",
  },
  {
    id: 6,
    descripcion: "Plazas disponibles",
    estado: "Datos cargados",
    path: "/establecimientos/plazaCamposPractica/crear",
  },
  {
    id: 7,
    descripcion: "Cronogramas aprobados",
    estado: "Datos cargados",
    path: "/establecimientos/cronograma/aprobados",
  },
  {
    id: 8,
    descripcion: "Confirmación de prácticas",
    estado: "Datos cargados",
    path: "/convenios/confirmacionesPracticasEstablecimientos",
  },
];

// Componente funcional `Form`
const Form = () => {
  const classes = useStyles();  // Hook para usar estilos personalizados (suponiendo que `useStyles` devuelve estilos CSS).
  const params = useParams();  // Hook de React Router para acceder a los parámetros de la URL.
  const [establecimientoId, setEstablecimientoId] = useState();  // Definición de un estado para almacenar el ID del establecimiento.
  const { hasRole } = useAuth();  // Hook que verifica roles de usuario (para permisos o autenticación).

  // Hook useEffect para ejecutar código al cargar el componente.
  useEffect(() => {
    // Extrae `establecimientoId` de los parámetros de la URL.
    let {establecimientoId} = params;

    // Si `establecimientoId` existe, actualiza el estado.
    if (establecimientoId) {
      setEstablecimientoId(establecimientoId);
    } else {
      // Si no existe, llama a la función `getEstablecimiento` para obtenerlo.
      getEstablecimiento();    
    }
  }, []);  // El array vacío indica que este código se ejecuta solo una vez, cuando el componente se monta.

  // Función asincrónica para obtener el ID del establecimiento desde una API.
  const getEstablecimiento = async () => {
    // Hace una solicitud GET a la API y obtiene datos sobre el establecimiento responsable.
    const { data } = await DnerhsApi.get("/instituciones/establecimientos/responsables/info");
    // Almacena el ID del establecimiento en el estado local.
    setEstablecimientoId(data.id);
  }

  // Función que maneja el evento cuando se hace clic en "Editar".
  // Redirige al usuario a la ruta correspondiente para editar la sección seleccionada.
  const handleClickEditar = (row) => {
    // Verifica si la ruta es para los cronogramas aprobados.
    if (row.path === "/establecimientos/cronograma/aprobados") {
      // Si es así, redirige sin agregar el ID del establecimiento en la URL.
      history.push({
        pathname: `${row.path}`,
        state: {
          readOnly: false,  // Configura el estado de la página como editable.
        },
      });
    } else {
      // Para cualquier otra ruta, redirige agregando el ID del establecimiento en la URL.
      history.push({
        pathname: `${row.path}/${establecimientoId}`,
        state: {
          readOnly: false,  // Configura el estado de la página como editable.
        },
      });
    }
  };

  // Función que maneja el evento cuando se hace clic en "Ver".
  // Redirige al usuario a la ruta correspondiente para ver la sección seleccionada, en modo de solo lectura.
  const handleClickVer = (row) => {
    history.push({
      pathname: `${row.path}/${establecimientoId}`,
      state: {
        readOnly: true,  // Configura el estado de la página como solo lectura.
      },
    });
  };


  return (
    <> 
     <Grid item xs={12}>
      <Grid item xs={12}>
        <Typography align="center" variant="h5" color="primary">
        { (establecimientoId!= "" && establecimientoId!= null) ? ( 'Establecimiento'  ) : ( 'El usuario, ya no cuenta con un establecimiento asignado' )}
        </Typography>
      </Grid>
      { (establecimientoId!= "" && establecimientoId!= null) ? (
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Paper>
            <Box p={1}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell align="left">Secciones</TableCell>
                    <TableCell align="right" />
                    {/* <TableCell align="left">Estado</TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {secciones.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell align="left">
                        {row.descripcion}
                      </TableCell>
                      <TableCell align="right">
                      {
                        (hasRole(Roles.ROLE_RESPONSABLE_ESTABLECIMIENTO)) &&
                        <Tooltip title="Editar" aria-label="editar">
                          <IconButton
                            aria-label="editar"
                            color="primary"
                          >
                            <EditIcon
                              onClick={() => handleClickEditar(row)}
                            />
                          </IconButton>
                        </Tooltip>
                      }
                      {
                        (hasRole(Roles.ROLE_DNERHS)) &&
                        <Tooltip title="Ver" aria-label="ver">
                        <IconButton
                          aria-label="editar"
                          color="primary"
                        >
                          <VisibilityIcon
                            onClick={() => handleClickVer(row)}
                          />
                        </IconButton>
                      </Tooltip>
                      }
                       
                      </TableCell>
                      {/* <TableCell align="left">{row.estado}</TableCell> */}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Paper>
        </Grid>
      </Grid>
      ) : (
        <Typography
          align="center"
          variant="h5"
          color="primary"
          className={classes.form}
        >
        </Typography>
       )}
       
      <Grid container direction="row" justifyContent="flex-end" alignItems="center">
        <Grid item className={classes.field}>
          <Button
            variant="contained"
            color="default"
            onClick={() =>  {
              (hasRole(Roles.ROLE_DNERHS)) ? (history.goBack() ) : (history.push(`/login`)) }}
          >
            Atrás
          </Button>
        </Grid>
      </Grid>
      </Grid>
    </>
  );
};

export default Form;
